import { render, staticRenderFns } from "./ArticleDataTable.vue?vue&type=template&id=4cc9c418"
import script from "./ArticleDataTable.vue?vue&type=script&lang=js"
export * from "./ArticleDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports